import ra68_jingtai from '../assets/presets/ra68_jingtai.txt?raw'
import ra68_huochairen from '../assets/presets/ra68_huochairen.txt?raw'
import mg75v2 from '../assets/presets/mg75v2.txt?raw'

import { HuoChaiRenDevices } from '@hid/define/define'

export const PRESET_CONFIGS = {
  /**
   * Jiangguowang
   */
  TITLT: '讲过往',
  JINGTAIVA_RA68_JIANGGUOWANG: ra68_jingtai,
  HUOCHAIREN_RA68_JIANGGUOWANG: ra68_huochairen,
  HUOCHAIREN_MG75V2_JIANGGUOWANG: mg75v2,
} as const
